export default function initReadMoreLess() {
  const testimonialText = document.querySelectorAll('.testimonial-text span');
  const readMoreLink = document.querySelectorAll('.read-more-link');

  if (!testimonialText.length || !readMoreLink.length) return;

  const updateHeights = () => {
    testimonialText.forEach((text, index) => {
      const link = readMoreLink[index];
      const originalHeight = text.clientHeight;
      const fullHeight = text.scrollHeight;

      // initial default height
      text.style.height = originalHeight + 'px';

      if (fullHeight > originalHeight) {
        link.style.display = 'inline-block';
        link.textContent = 'Read more';
      } else {
        link.style.display = 'none';
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = text.classList.contains('expanded');

        text.classList.toggle('expanded');

        text.style.height = isExpanded ? originalHeight + 'px' : fullHeight + 'px';
        link.textContent = isExpanded ? 'Read more' : 'Read less';
      });
    });
  };

  updateHeights();

  window.addEventListener('resize', () => {
    requestAnimationFrame(updateHeights);
  });
}
